module.exports = __webpack_public_path__ + "static/media/Q3.c3b80a26.png";